import Api from 'api/index'

const config = {
  baseURL: '/api/app/v2',
}
const api = new Api(config)

api.accountAccessCreate = ({ networkId, accountId, ...rest }) =>
  api.post(`/networks/${networkId}/accounts/${accountId}/invites`, {
    ...rest,
  })

export default api
